import classNames from 'classnames';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

import { ListField } from './ListField';

type OwnProps = {
  value: string;
  disabled?: boolean;
  isLoading: boolean;
  onChange: (newFightingBackJustification: string) => void;
};

export const FightingBackJustification: FC<OwnProps> = ({ value, disabled, isLoading, onChange }) => {
  if (isLoading) {
    return (
      <div className="form-control readonly">
        <Skeleton width="15em" />
      </div>
    );
  }

  return (
    <ListField
      id="fightingBackJustification"
      e2e="fightback-justification"
      translationKey="form.FightingBackJustification"
      availableItems={[
        { label: null, value: '' },
        { label: 'Split/Allocation', value: 'FB3' },
        { label: 'Third party error/request', value: 'FB2' },
        { label: 'FO error', value: 'FB1' },
      ]}
      disabled={disabled}
      value={value}
      onValueChange={onChange}
      className={classNames('mb-0', {
        'is-warning': !disabled && (value === null || value === ''),
      })}
    />
  );
};

FightingBackJustification.displayName = 'FightingBackJustification';
